import { Controller } from '@hotwired/stimulus';
import tippy from 'tippy.js';

export default class extends Controller {
  connect() {
    this.tippyInstances = [];
    const elements = document.querySelectorAll('a.wiki');

    for (const element of elements) {
      if (this.isMobileDevice()) {
        // Click and Hover conflicts on touch displays, so disable click
        // (and add additional link inside the popup later)
        element.onclick = (e) => {
          e.preventDefault();
        };
        element.classList.add('cursor-default');
      }

      const instance = this.createInstance(element, this);
      this.tippyInstances.push(instance);
    }
  }

  disconnect() {
    if (!this.tippyInstances) return;
    Array.from(this.tippyInstances).forEach((instance) => {
      if (instance) instance.destroy();
    });
  }

  createInstance(element, that) {
    const loadingText = this.isGerman() ? 'Wird geladen...' : 'Loading...';
    const moreText = this.isGerman() ? 'Mehr' : 'More';

    return tippy(element, {
      content: loadingText,
      allowHTML: true,
      arrow: true,
      touch: true,
      theme: 'light-border',
      animation: 'scale',
      interactive: true,
      appendTo: document.body,

      // Code inspired from https://atomiks.github.io/tippyjs/v6/ajax/
      //////////////////////////
      onCreate(instance) {
        // Setup our own custom state properties
        instance._isFetching = false;
        instance._fetched = null;
        instance._error = null;
      },

      onShow(instance) {
        if (instance._isFetching || instance._fetched || instance._error) {
          return;
        }
        instance._isFetching = true;

        fetch(element.href + '.json', {
          headers: { accept: 'application/json' },
        })
          .then(async (response) => {
            if (response.ok) {
              const data = await response.json();
              let moreLink = '';
              if (that.isMobileDevice())
                moreLink = `<a target="_blank" class="block mt-3" href="${element.href}">${moreText}...</a>`;
              instance.setContent(
                `<div class="prose-sm p-1"><h5>${data.title}</h5>${data.introduction}${moreLink}</div>`,
              );
            } else {
              instance.setContent(
                `<div class="prose-sm p-1"><h5 class="text-red-500">Fehler, Wiki-Artikel nicht gefunden!</h5><p class="font-mono">${element.href}</p></div>`,
              );
            }
            instance._fetched = true;
          })
          .catch((error) => {
            instance._error = error;
            instance.setContent(`Request failed. ${error}`);
          })
          .finally(() => {
            instance._isFetching = false;
          });
      },

      onHidden(instance) {
        instance.setContent(loadingText);
        // Unset these properties so new network requests can be initiated
        instance._fetched = null;
        instance._error = null;
      },
    });
  }

  isMobileDevice() {
    return (
      'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0
    );
  }

  isGerman() {
    return document.documentElement.lang.startsWith('de');
  }
}
